import { Shield, ShieldCheck, Lock } from 'lucide-react';

const certifications = [
  {
    title: 'ISO 27001:2022 Certified',
    icon: ShieldCheck,
  },
  {
    title: 'IEC 82304-1:2016 Certified',
    icon: Shield,
  },
  {
    title: 'Followed Healthcare IT Security Policy',
    icon: Lock,
  },
];

const Certifications = () => {
  return (
    <section className="py-10 bg-slate-50 border-t border-gray-200" data-testid="certifications-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
            {certifications.map((cert, index) => (
              <div key={index} className="flex items-center gap-3" data-testid={`certification-${index}`}>
                <div className="w-12 h-12 rounded-full bg-[#1a2a5e]/10 flex items-center justify-center flex-shrink-0">
                  <cert.icon className="h-6 w-6 text-[#1a2a5e]" />
                </div>
                <span className="font-semibold text-[#1a2a5e] text-sm md:text-base">{cert.title}</span>
              </div>
            ))}
          </div>
          <p className="text-sm text-gray-500 text-center max-w-2xl">
            Our platform follows Global Health IT standards including ISO 27001:2022 and IEC 82304-1:2016.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
